import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { fetchRejected } from 'Redux/carts/actions'

const useCartsRejected = () => {
  const dispatch = useDispatch()

  const data = useSelector(state => state.carts.rejected)
  const isFetching = useSelector(state => state.carts.isFetchingRejected)
  const filterProviders = useSelector(state => state.carts.filterProviders)
  const filterRequestNumber = useSelector(state => state.carts.filterRequestNumber)

  const isFilterActive = !!filterProviders?.length || !!filterRequestNumber

  useEffect(() => {
    dispatch(fetchRejected())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterProviders, filterRequestNumber])

  return { data, isFetching, isFilterActive }
}

export default useCartsRejected
